module.exports = __webpack_public_path__ + "static/media/OwnAccom.951465b8.png";